const settingsConfig = {
	layout: {
		style: 'layout',
		config: {} // checkout layout configs at app/fuse-layouts/layout/LayoutConfig.js
	},
	customScrollbars: true,
	theme: {
		main: 'default',
		navbar: 'mainThemeDark',
		toolbar: 'mainThemeLight',
		footer: 'mainThemeDark'
	}
};

export default settingsConfig;
